// extracted by mini-css-extract-plugin
export default {"box":"BlogList_box__n+MMn"};